// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"0":"40b11336","501":"bc9ed639","778":"50baaa20","899":"14e36efe"}[chunkId] + ".js";
};